import { alpha, Box, Card, CardContent, IconButton, Stack, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const SummaryCard = ({
  title,
  count,
  icon,
  active,
  color,
  onClick,
  onAdd,
}: {
  title: string;
  count: number;
  icon: any;
  active?: boolean;
  color?: string;
  onClick?: () => void;
  onAdd?: () => void;
}) => {
  const theme = useTheme();
  const baseColor = color || theme.palette.primary.main;

  return (
    <Card
      className="glass-card-light"
      onClick={onClick}
      sx={{
        flex: 1,
        minWidth: 'auto',
        bgcolor: active ? alpha(baseColor, 0.08) : 'rgba(255, 255, 255, 0.4)',
        borderColor: active ? baseColor : 'divider',
        borderWidth: active ? 2 : 1,
        transition: 'all 0.3s ease',
        boxShadow: 'none',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              transform: 'translateY(-2px)',
              boxShadow: `0 8px 24px ${alpha(baseColor, 0.12)}`,
              borderColor: baseColor,
            }
          : {},
      }}
    >
      <CardContent sx={{ p: '8px !important' }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Box
            sx={{
              p: 0.75,
              borderRadius: '8px',
              bgcolor: alpha(baseColor, 0.1),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: baseColor,
            }}
          >
            {icon}
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 700,
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: 0.2,
                fontSize: '9px',
              }}
            >
              {title}
            </Typography>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'text.primary', lineHeight: 1 }}>
              {count}
            </Typography>
          </Box>
          {onAdd && (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onAdd();
              }}
              sx={{
                width: 22,
                height: 22,
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                color: 'primary.main',
                transition: 'background-color 0.2s ease',
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.2) },
              }}
            >
              <AddIcon sx={{ fontSize: 13 }} />
            </IconButton>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;
